import * as THREE from 'three';

/** Flat shadow-receiving floor at y = 0, with a faint grid for scale. */
export function createGround(size = 40) {
  const group = new THREE.Group();
  group.name = 'ground';

  const plane = new THREE.Mesh(
    new THREE.PlaneGeometry(size, size),
    new THREE.MeshStandardMaterial({ color: 0x2a2f3c, roughness: 0.95, metalness: 0 })
  );
  plane.rotation.x = -Math.PI / 2;
  plane.receiveShadow = true;
  group.add(plane);

  const grid = new THREE.GridHelper(size, size, 0x4d5568, 0x3a4152);
  grid.position.y = 0.002;
  group.add(grid);

  return group;
}
